import ScreenReaderOnly from '../../accessibility/ScreenReaderOnly';
import verified_user from '@sb1/ffe-icons/icons/filled/sm/verified_user.svg';
import not_verified_user from '@sb1/ffe-icons/icons/open/300/sm/shield.svg';
import { Icon } from '@sb1/ffe-icons-react';
import styles from './VerificationBadge.module.less';

const VerificationBadge = ({ verified, className = '' }) => {
    const iconWrapper = verified ? styles.verified : null;
    const icon = verified ? verified_user : not_verified_user;
    const title = verified ? 'Verifisert' : 'Ikke-verifisert';

    return (
        <span className={[iconWrapper, className].join(' ')}>
            <Icon fileUrl={icon} size={'sm'} aria-hidden={true} title={title} className={styles.icon} />
            <ScreenReaderOnly>{title}</ScreenReaderOnly>
        </span>
    );
};

export default VerificationBadge;
